import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { mergeClasses } from '../../helpers/styling'
import { createPortalAnchor, usePortalContainer } from "../../shared/portal-layers"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = createPortalAnchor(PopoverPrimitive.Trigger)

const PopoverAnchor = createPortalAnchor(PopoverPrimitive.Anchor)

const PopoverClose = PopoverPrimitive.PopoverClose

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { portalContainer?: Element | null }
>(({
    className,
    portalContainer,
    align = "center",
    sideOffset = 4,
    ...props }, ref
) => {
  const defaultContainer = usePortalContainer()
  return (
    <PopoverPrimitive.Portal container={portalContainer ?? defaultContainer}>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={mergeClasses(
          "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent, PopoverClose }
